.activity-steps {
  margin-top: 32px;
  width: 100%;
}
